import { render } from "./DetachTrailerSuccess.vue?vue&type=template&id=0126da6a&scoped=true&ts=true"
import script from "./DetachTrailerSuccess.vue?vue&type=script&lang=ts"
export * from "./DetachTrailerSuccess.vue?vue&type=script&lang=ts"

import "./DetachTrailerSuccess.vue?vue&type=style&index=0&id=0126da6a&lang=scss&scoped=true"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0126da6a"]])

export default __exports__